export default "__VITE_ASSET__3eb02a50__"